import React from "react";
import { Container } from "react-bootstrap";
import styles from "./index.module.css";

const RatesSection = () => {
  return (
    <Container fluid className={styles.rates_info_section}>
      <p className={`${styles.max_width_limit} ${styles.mb_small}`}>
        <div className={styles.mb_small}>
          Become a Sun West Loan Originator and ditch your average loan officer
          commission. Sun West offers amazing pricing and exceptional underwriting.{" "}
        </div>
        <div className={styles.mb_small}>
         Our local management combined with our exclusive{" "}
          <a href="https://angelai.com" target="_blank" rel="noreferrer">
            AngelAi  
          </a>{" "}
          technology eliminates the need for multiple layers and obstacles between your branch
          and the Sun West executive management. No Layers = Fast Decisions.
        </div>
        <div className={styles.mb_small}>
          Our Partner model scales to any size branch from one originator to
          hundreds of originators. Partners get access to{" "}
          <a href="https://angelai.com" target="_blank" rel="noreferrer">
            AngelAi
          </a>
          , Sun West proprietary and patented retail technology.
        </div>
      </p>
    </Container>
  );
};

export default RatesSection;
